import { useTranslation } from "react-i18next"

type TranslateFunction = ReturnType<typeof useTranslation>["t"]

const NO_RECORD_FOUND_RETURN_CODE = "1"
const SEARCH_REFUSED_RETURN_CODE = "4"

export const describeLookupFailure = (
  translate: TranslateFunction,
  returnCode: string | null,
  returnMessage: string | null,
  errorMessage: string | null,
): string => {
  if (errorMessage !== null) {
    return translate("admin.sasisLookup.requestFailed", { errorMessage })
  }

  if (returnCode === NO_RECORD_FOUND_RETURN_CODE) {
    return translate("admin.sasisLookup.noMatch")
  }

  if (returnCode === SEARCH_REFUSED_RETURN_CODE) {
    return translate("admin.sasisLookup.invalidSearch", { returnMessage: returnMessage ?? "" })
  }

  if (returnCode === null) {
    return translate("admin.sasisLookup.noResponse")
  }

  return translate("admin.sasisLookup.otherReturnCode", { returnCode, returnMessage: returnMessage ?? "" })
}
